import React from "react";
import Footer from "../../common/Footer/Footer";
import Header from '../../common/Header/Header';
import AboutUs from "../../components/AboutUs/AboutUs";
import SEO from "../../components/SEO/SEO";

const AboutUsPage = () => {
  return (
    <div>
      <SEO
        title="About Us"
        description="Learn about MindTherapy Counselling — our mission, values, and the team behind the platform. We're committed to making mental health support accessible to everyone."
        canonical="https://mindtherapycounselling.com/aboutUs"
      />
      <Header />
      <AboutUs />
      <Footer />
    </div>
  );
};

export default AboutUsPage;
